import Crud from '../views/Acquisition/Crud'
import Entity from '../views/Acquisition/Add'


let routes = {
    path: '/acquisitions',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/acquisitions/add',
            name: 'NewAcquisition',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de aquisição',
                breadcrumb: [
                    {
                        text: 'Tipos de aquisição',
                        active: false,
                        to: '/acquisitions',
                    },
                    {
                        text: 'Adicionar tipo de aquisição',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/acquisitions/edit/:id?',
            name: 'EditAcquisition',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de aquisição',
                breadcrumb: [
                    {
                        text: 'Tipos de aquisição',
                        active: false,
                        to: '/acquisitions',
                    },
                    {
                        text: 'Editar tipo de aquisição',
                        active: true,
                    }
                ],
            }, 
        },
        {
            path: '/acquisitions',
            name: 'list-acquisitions',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de aquisição',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
